import { render, staticRenderFns } from "./props.vue?vue&type=template&id=14110b92&scoped=true&"
import script from "./props.vue?vue&type=script&lang=js&"
export * from "./props.vue?vue&type=script&lang=js&"
import style0 from "./props.vue?vue&type=style&index=0&id=14110b92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14110b92",
  null
  
)

export default component.exports